// -- copyright
// OpenProject is an open source project management software.
// Copyright (C) 2012-2024 the OpenProject GmbH
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
//
// See COPYRIGHT and LICENSE files for more details.
//++
import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: 'op-drag-scroll',
})
export class OpDragScrollDirective implements OnInit {
  constructor(readonly elementRef:ElementRef) {
  }

  ngOnInit() {
    const element = jQuery(this.elementRef.nativeElement);
    const eventName = 'op:dragscroll';

    // Is mouse down?
    let mousedown = false;

    // Position of last mousedown
    let mousedownX:number; let
      mousedownY:number;

    // Mousedown: Potential drag start
    element.on('mousedown', (evt) => {
      setTimeout(() => {
        mousedown = true;
        mousedownX = evt.clientX;
        mousedownY = evt.clientY;
      }, 50, false);
    });

    // Mouseup: Potential drag stop
    element.on('mouseup', () => {
      mousedown = false;
    });

    // Mousemove: Report movement if mousedown
    element.on('mousemove', (evt) => {
      if (!mousedown) {
        return;
      }

      // Trigger drag scroll event
      element.trigger(eventName, {
        x: evt.clientX - mousedownX,
        y: evt.clientY - mousedownY,
      });

      // Update last mouse position
      mousedownX = evt.clientX;
      mousedownY = evt.clientY;
    });
  }
}
